/**
 * @generated SignedSource<<560a73d09ecdae61f3bf4f234c056435>>
 * @relayHash 695981f2abe893fe5dc9b010759768a2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID b685969d95b4a5f834408344b10d34fbb7a5b28800d8c250af7f494580320653

import type { ConcreteRequest } from 'relay-runtime';
export type JiraBoardLocationType = "PROJECT" | "USER" | "%future added value";
export type JiraBoardType = "KANBAN" | "SCRUM" | "%future added value";
export type JiraCreateBoardInput = {
  createBoardSource: JiraCreateBoardSource;
  location: JiraBoardLocation;
  name: string;
  preset: JiraBoardType;
};
export type JiraCreateBoardSource = {
  fieldInput?: JiraCreateBoardFieldInput | null;
  savedFilterId?: AGG$Long | null;
};
export type JiraCreateBoardFieldInput = {
  issueTypes?: ReadonlyArray<JiraIssueTypeInput> | null;
  labels?: ReadonlyArray<JiraLabelsInput> | null;
  projects: ReadonlyArray<JiraProjectInput>;
  teams?: ReadonlyArray<JiraAtlassianTeamInput> | null;
};
export type JiraIssueTypeInput = {
  id?: string | null;
  issueTypeId: string;
};
export type JiraLabelsInput = {
  name?: string | null;
};
export type JiraProjectInput = {
  id?: string | null;
  projectId: string;
};
export type JiraAtlassianTeamInput = {
  teamId: string;
};
export type JiraBoardLocation = {
  locationId?: string | null;
  locationType: JiraBoardLocationType;
};
export type useBoardCreateMutationUseBoardCreateMutation$variables = {
  cloudId: string;
  input: JiraCreateBoardInput;
};
export type useBoardCreateMutationUseBoardCreateMutation$data = {
  readonly jira: {
    readonly createBoard: {
      readonly board: {
        readonly __id: string;
        readonly boardId: AGG$Long | null;
        readonly boardType: JiraBoardType | null;
        readonly boardUrl: AGG$URL | null;
        readonly id: string;
        readonly name: string | null;
      } | null;
      readonly errors: ReadonlyArray<{
        readonly extensions: {
          readonly errorType: string | null;
          readonly statusCode: number | null;
        } | null;
        readonly message: string | null;
      }> | null;
      readonly success: boolean;
    } | null;
  } | null;
};
export type useBoardCreateMutationUseBoardCreateMutation = {
  response: useBoardCreateMutationUseBoardCreateMutation$data;
  variables: useBoardCreateMutationUseBoardCreateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  },
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "id"
},
v3 = {
  "concreteType": "JiraBoard",
  "kind": "LinkedField",
  "name": "board",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "boardId"
    },
    {
      "kind": "ScalarField",
      "name": "name"
    },
    (v2/*: any*/),
    {
      "kind": "ScalarField",
      "name": "boardType"
    },
    {
      "kind": "ScalarField",
      "name": "boardUrl"
    },
    {
      "kind": "ClientExtension",
      "selections": [
        {
          "kind": "ScalarField",
          "name": "__id"
        }
      ]
    }
  ]
},
v4 = {
  "kind": "ScalarField",
  "name": "success"
},
v5 = {
  "kind": "ScalarField",
  "name": "message"
},
v6 = {
  "kind": "ScalarField",
  "name": "errorType"
},
v7 = {
  "kind": "ScalarField",
  "name": "statusCode"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useBoardCreateMutationUseBoardCreateMutation",
    "selections": [
      {
        "concreteType": "JiraMutation",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "JiraCreateBoardPayload",
            "kind": "LinkedField",
            "name": "createBoard",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              {
                "concreteType": "MutationError",
                "kind": "LinkedField",
                "name": "errors",
                "plural": true,
                "selections": [
                  (v5/*: any*/),
                  {
                    "kind": "LinkedField",
                    "name": "extensions",
                    "plural": false,
                    "selections": [
                      (v6/*: any*/),
                      (v7/*: any*/)
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useBoardCreateMutationUseBoardCreateMutation",
    "selections": [
      {
        "concreteType": "JiraMutation",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "JiraCreateBoardPayload",
            "kind": "LinkedField",
            "name": "createBoard",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              {
                "concreteType": "MutationError",
                "kind": "LinkedField",
                "name": "errors",
                "plural": true,
                "selections": [
                  (v5/*: any*/),
                  {
                    "kind": "LinkedField",
                    "name": "extensions",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "__typename"
                      },
                      (v6/*: any*/),
                      (v7/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v2/*: any*/)
                        ],
                        "type": "BulkMutationErrorExtension"
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "b685969d95b4a5f834408344b10d34fbb7a5b28800d8c250af7f494580320653",
    "metadata": {},
    "name": "useBoardCreateMutationUseBoardCreateMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "6eb43d009e445cc60fd2bd47fc2adb71";

export default node;
